<template>
  <section class="houseDetails">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in imgList">
          <img class="image" :src="item">
        </div>
      </div>
      <div class="swiper-slide swiper-button-prev"></div>
      <div class="swiper-slide swiper-button-next"></div>
      <div class="openPanorama" @click="goLink" v-show="detaliData.vr_link">
        <img src="../../assets/img/xzhuan.png" alt="">
      </div>
      <!-- 如果需要滚动条 -->
      <div class="swiper-scrollbar"></div>
    </div>
    <div class="house_title">
      <div class="name">{{detaliData.project_full_name}} - {{detaliData.room_type_alias}}</div>
      <div class="price">
        <span>{{detaliData.month_price}}</span>元/月起
      </div>
      <div class="fangx">
        <div class="btn" @click="openFrom"><img src="../../assets/img/yuyue.png" alt=""><span>预约看房</span></div>
      </div>
    </div>
    <div class="contene">
      <div class="details">
        <div class="info">
          <div class="title">
            <img src="../../assets/img/fangx.png" alt=""><span>房型信息</span>
          </div>
          <ul class="clearfix">
            <li>
              <p>可入住日期</p>
              <p>{{nowTime}}</p>
            </li>
            <li>
              <p>房型</p>
              <p>{{detaliData.room_type_alias}}</p>
            </li>
            <li>
              <p>床位</p>
              <p>{{detaliData.bed_num_str}}</p>
            </li>
            <li>
              <p>最多可入住</p>
              <p>{{detaliData.livein_num_str}}</p>
            </li>
            <li>
              <p>建筑面积</p>
              <p>{{detaliData.area}}平</p>
            </li>
            <li>
              <p>装修风格</p>
              <p>{{detaliData.house_style}}</p>
            </li>
          </ul>
        </div>
        <div class="facilities">
          <div class="title">
            <img src="../../assets/img/shez.png" alt=""><span>配套设施</span>
          </div>
          <ul>
            <li v-for="(item, index) in detaliData.device_pic" :key="index">
              <img :src="item.device_pic" alt="" width="40" height="40">
              <span>{{item.device_name}}</span>
            </li>
            <!-- <li>
              <img src="../../assets/img/bingx.png" alt="">
              <span>冰箱</span>
            </li>
            <li>
              <img src="../../assets/img/pent.png" alt="">
              <span>热水器</span>
            </li>
            <li>
              <img src="../../assets/img/xiyij.png" alt="">
              <span>洗衣机</span>
            </li>
            <li>
              <img src="../../assets/img/dians.png" alt="">
              <span>电视</span>
            </li>
            <li>
              <img src="../../assets/img/chuang.png" alt="">
              <span>床</span>
            </li>
            <li>
              <img src="../../assets/img/mens.png" alt="">
              <span>智能门锁</span>
            </li>
            <li>
              <img src="../../assets/img/req.png" alt="">
              <span>暖气</span>
            </li>
            <li>
              <img src="../../assets/img/chuifj.png" alt="">
              <span>电吹风</span>
            </li>
            <li>
              <img src="../../assets/img/wifi.png" alt="">
              <span>无线网络</span>
            </li> -->
          </ul>
        </div>
        <!-- <div class="huanj">
          <div class="title">
            <img src="../../assets/img/huanj.png" alt=""><span>社区环境</span>
          </div>
          <div class="swiper-container1">
        　　<div class="swiper-wrapper">
              <div class="swiper-slide img" v-for="item in imgList" @click="showImg">
                <img src="http://t9.baidu.com/it/u=2268908537,2815455140&fm=79&app=86&f=JPEG?w=1280&h=719">
              </div>
        　　</div>
          </div>
        </div> -->
        <div class="traffic">
          <div class="title">
            <img src="../../assets/img/jiaot.png" alt=""><span>交通出行</span>
          </div>
          <div class="diz">
            <div>
              <img src="../../assets/img/1dianw.png" alt="">
            </div>
            <div>
              <p>{{detaliData.simple_location}}</p>
              <p>{{detaliData.traffic_desc}}</p>
            </div>
          </div>
        </div>
        <div class="mapriq">
          <div class="title">
            <img src="../../assets/img/dituicon.png" alt=""><span>位置地图</span>
          </div>
          <div class="map" id="allmap">

          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="预约看房"
      :visible.sync="dialogVisible"
      custom-class="myDialog"
      >
      <appointment ref="appointment" v-if="dialogVisible" @changeState="changeState" ></appointment>
      <div class="btn">
        <span @click="submit" v-if="!type">提交</span>
        <span @click="dialogVisible = false" v-if="type">关闭</span>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {mapMutations} from 'vuex'
  import Swiper from 'swiper'
  import {getHouseDetaliApi} from '../../services/api'
  import 'swiper/css/swiper.min.css'
  import dadingw from '../../assets/img/dadingw.png'
  import appointment from '../../components/appointmentForm.vue'
  export default {
    data() {
      return {
        id: '',
        imgList: [],
        detaliData: {},
        dialogVisible: false,
        type: ''
      }
    },
    metaInfo () {
      if(this.detaliData && this.detaliData.project_full_name){
        return {
          title: this.detaliData.project_full_name + ' - ' + this.detaliData.room_type_alias,
        }
      }
    },
    computed:{
      nowTime() {
        let date = new Date();
        return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
      }
    },
    methods: {
      ...mapMutations([
        'setActiveCity'
      ]),
      baiduMap(longtitude, latitude) {
        var map = new BMap.Map('allmap') // 创建地图实例

        var point = new BMap.Point(longtitude, latitude) // 创建点坐标
        map.centerAndZoom(point, 15) // 初始化地图，设置中心点坐标和地图级别
        map.enableScrollWheelZoom(true) //开启鼠标滚轮缩放

        map.addControl(new BMap.NavigationControl())
        map.addControl(new BMap.ScaleControl())
        map.addControl(new BMap.OverviewMapControl())
        map.addControl(new BMap.MapTypeControl({
          mapTypes:[
            BMAP_NORMAL_MAP
          ]
        }))

        //map.setMapStyle({ style: 'midnight' }) //地图风格
        var myIcon = new BMap.Icon(dadingw, new BMap.Size(106, 90), {
            anchor: new BMap.Size(53, 75),
        })
        var marker = new window.BMap.Marker(point, {icon: myIcon}) // 创建标注
        map.addOverlay(marker) // 将标注添加到地图中

        //提示信息
        // var infoWindow = new BMap.InfoWindow('这是提示信息')
        // 鼠标移上标注点要发生的事
        // marker.addEventListener('mouseover', function() {
        //     this.openInfoWindow(infoWindow)
        // })

        // 鼠标移开标注点要发生的事
        marker.addEventListener('mouseout', function() {
            //this.closeInfoWindow(infoWindow)
        })
      },
      goLink() {
        window.open(this.detaliData.vr_link)
      },
      openFrom() {
        this.type = ''
        this.dialogVisible = true
      },
			submit() {
				this.$refs.appointment.submit()
			},
      showImg() {
        console.log('查看')
      },
			changeState(type){
				this.type = type
			},
    },
    mounted() {
      this.id = this.$route.params.id.substr(0, this.$route.params.id.length - 5)
      getHouseDetaliApi(this.id).then(res => {
        this.detaliData = res.app_house_dto
        this.setActiveCity({city_id: this.detaliData.city_id, project_id: this.detaliData.project_id, room_type_id: this.detaliData.room_type_id})
        this.imgList = this.detaliData.room_pic
        this.baiduMap(this.detaliData.longtitude, this.detaliData.latitude)
        this.$nextTick(()=>{
          let _this = this
          var mySwiper = new Swiper(".swiper-container",{
              autoplay:true,
              slidesPerView: 3,
              spaceBetween: 10,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              loop: true
          })
          // var mySwiper1 = new Swiper(".swiper-container1", {
          //   speed:1500,//匀速时间
          //   spaceBetween: 10,
          //   autoplay : 1,
          //   freeMode:true,
          //   slidesPerView : 5,
          // })
        })
      })
    },
		components: {
			appointment
		}
  }
</script>

<style lang="stylus">
  .houseDetails
    font-family PingFangSC-Regular
    background-color #fff
    /* 去除百度地图版权那行字 和 百度logo */
    .map > .BMap_cpyCtrl
        display: none !important
    .map .anchorBL
      display: none !important
    .swiper-container1
      -webkit-transition-timing-function: linear /*之前是ease-out*/
      -moz-transition-timing-function: linear
      -ms-transition-timing-function: linear
      -o-transition-timing-function: linear
      transition-timing-function: linear
    .swiper-container
      background-color #103A40
      .image
        height 450px
        width 100%
      .openPanorama
        cursor pointer
        width 40px
        height 40px
        position absolute
        right: calc(33.33% + 10px)
        z-index: 99
        top: 10px
        background:url(../../assets/img/360.png) no-repeat center
        img
          width 40px
          height 40px
          margin-top 2px
          animation: rotate 5s linear infinite
        @keyframes rotate
          from
            transform: rotate(0deg)
          to
            transform: rotate(-360deg)
    .swiper-slide
      overflow: hidden
    .swiper-button-next
      width 60px
      height 60px
      margin-right 85px
      background:url(../../assets/img/you.png) no-repeat
      opacity 0.5
      transition all 0.3s
      &:after
        content: ''
      &:hover
        opacity 1
        transition all 0.3s
    .swiper-button-prev
      width 60px
      height 60px
      margin-left 85px
      background:url(../../assets/img/zuo.png) no-repeat
      opacity 0.5
      transition all 0.3s
      &:after
        content: ''
      &:hover
        opacity 1
        transition all 0.3s
    .house_title
      width 1120px
      margin 0 auto
      padding 0 40px
      background-color #fff
      height 94px
      display: flex
      justify-content: space-between
      align-items: center
      .name
        font-size 30px
        color #000
        font-weight 400
      .price
        font-size 14px
        color #272727
        font-weight 600
        span
          color #00B8D4
          font-size 30px
          margin-right 10px
      .fangx
        .btn
          padding 10px 22px 10px 18px
          color #fff
          background:linear-gradient(90deg,rgba(127,241,251,1),rgba(0,184,212,1))
          box-shadow:0px 2px 8px 1px rgba(80,181,208,0.29)
          font-size 18px
          border-radius 32px
          display flex
          align-items center
          transition all 0.3s
          cursor pointer
          &:hover
            box-shadow:0px 2px 8px 1px rgba(80,181,208,0.7)
            transition all 0.3s
          img
            width 35px
            height 32px
            margin-right 13px
    .contene
      padding 20px 0 95px 0
      background-color #F0F2F7
      .details
        width 1120px
        margin  0 auto
        padding 19px 40px 50px 40px
        background-color #fff
        .info
          .title
            border-bottom: 1px solid #DFE2EA
            padding-bottom: 15px
            display flex
            img
              width 23px
              height 21px
              margin-right 10px
            span
              color #272727
              font-size 14px
              font-weight 600
          ul
            padding 24px 0
            li
              margin-bottom 30px
              width 20%
              float left
              p:first-child
                color #999999
                font-size 12px
                font-weight 400
              p:last-child
                margin-top 15px
                color #272727
                font-size 14px
                font-weight 400
        .facilities
          .title
            border-bottom: 1px solid #DFE2EA
            padding-bottom: 15px
            display flex
            img
              width 23px
              height 21px
              margin-right 10px
            span
              color #272727
              font-size 14px
              font-weight 600
          ul
            display flex
            // justify-content space-between
            padding 40px 0 50px 0
            li
              text-align center
              width 10%
              img
                width 40px
                height 40px
              span
                display block
                color #272727
                font-size 14px
                font-weight 400
                margin-top 5px
        .huanj
          overflow hidden
          .title
            border-bottom 1px solid #DFE2EA
            padding-bottom 15px
            display flex
            img
              width 23px
              height 21px
              margin-right 10px
            span
              color #272727
              font-size 14px
              font-weight 600
          .img
            margin-top 24px
            width 196px!important
            cursor pointer
            transition all 0.5s
            &:hover
              transition all 0.5s
              transform scale(1.1)
            img
              width 196px
              height 158px
        .traffic
           margin-top 50px
          .title
            border-bottom 1px solid #DFE2EA
            padding-bottom 15px
            display flex
            img
              width 23px
              height 21px
              margin-right 10px
            span
              color #272727
              font-size 14px
              font-weight 600
          .diz
            margin-top 20px
            display flex
            img
              width 14px
              height 17px
            p
              font-size 14px
              color #666666
              font-weight 400
              margin-left 12px
              &:last-child
                margin-top 10px
        .mapriq
           margin-top 50px
          .title
            border-bottom 1px solid #DFE2EA
            padding-bottom 15px
            display flex
            img
              width 23px
              height 21px
              margin-right 10px
            span
              color #272727
              font-size 14px
              font-weight 600
          .map
            margin-top 24px
            height 450px
            background-color #00FFFF
    .myDialog
      width 840px
      font-family PingFangSC-Regular
      .el-dialog__header
        font-family PingFangSC-Regular
        padding 16px 25px
        background #00B8D4
        .el-dialog__title
          color: #fff
        i
          font-size 28px
          color: #fff
      .el-dialog__body
        .btn
          text-align center
          span
            font-weight 400
            font-size 16px
            color #fff
            background-color #00B8D4
            padding 12px 42px
            border-radius 5px
            cursor pointer
</style>
